export default __webpack_public_path__ + "static/media/slide-banner2.f45161e8.png";